.breadcrumbs{
  display: flex;
  align-items: center;
  height: 34px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: var(--ion-color-step-800);
}

.view-drawing-set {
  float: right;
  position: absolute;
  right: 6px;
}

.scroll-container {
  height: calc(100% - 34px);
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: grey transparent;
  scrollbar-gutter: stable;
}

#files-table {
  width: 100%;
  border-collapse: collapse;
}

#files-table td, #files-table th {
  border: none;
}

#files-table .small-centered{
  width: 80px;
  text-align: center;
}

/* no first row on mobile */
@media (min-width: 576px) {
  #files-table tr:first-child {
    cursor: pointer;
    text-decoration: underline;
    background-color: #686767 !important; 
    position: sticky;
    top: 0;
    z-index: 2;
  }
}

#files-table tr:nth-child(odd) {
  background-color: #292929;
}

#files-table th {
  text-align: left;
  padding:  8px !important;
}

a {
  cursor: pointer;
}

.small-heading {
  font-size: small;
  color: var(--color-grey-3, #4e4e4e);
}

.sort-desc {
  background-image: url(/assets/icon/down-arrow.svg);
  background-position:  bottom 10px right 6px;
  background-repeat: no-repeat;
  background-size: 14px 14px;
  padding-right: 28px !important; /* override styles from ionic */
}

.sort-asc {
  background-image: url(/assets/icon/up-arrow.svg);
  background-position:  bottom 10px right 6px;
  background-repeat: no-repeat;
  background-size: 14px 14px;
  padding-right: 28px !important; /* override styles from ionic */
}

.down-pulse {
  display: inline-block;
  font-size: 24px; /* adjust size as needed */
  animation: moveDown 0.8s ease-in-out infinite;
}

@keyframes moveDown {
  0% { transform: translateY(-6px); opacity: 0.2; }
  100% { transform: translateY(0); opacity: 1; }
}

.thumb {
  display: inline-block;
  margin: 4px;
  position: relative;
  vertical-align: top;
  cursor: pointer;
}

.thumb img{
  display: block;
  border: 1px solid grey;
  min-width: 60px; /* some thumbs don't render, this helps make it still visible */
  min-height: 100px;
}

.thumb-label {
  padding-top: 4px;
  overflow: hidden;
}

.thumb-label small {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.nowrap {
  white-space: nowrap;
}

.file-row {
  height: 68px
}

/** Width + padding + margin = thumb-tiny.width */
.folder-tiny {
  width: 40px;
  height: 40px;
  padding: 10px;
  margin: 4px;
  color: lightgray;
}

.thumb-tiny {
  width: 60px;
  height: 60px;
  background-size: cover;
  border: 1px solid lightgray; /* Gives a photo border effect */
  margin: 4px;
}

.status-icon {
  font-size: 24px;
}

/**
 * We want the checkbox column to be sticky to the right.
 * so that on small screens, the checkbox is always visible.
 */
.checkbox-col {
  position: sticky;
  right: 0;
  z-index: 2;
}

.checkbox-col ion-checkbox {
  --border-color: var( --ion-color-step-500, wheat);
  --border-width: 1px;
}

.footer-selected-info {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  border-radius: 40px;
  display: flex;
  flex-flow: row;
  white-space: nowrap;
  vertical-align: middle;
  width: max-content;
  padding-right: 6px;
}

.center-text {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}


.link-button {
  --color: var(--ion-text-color);
  text-decoration: underline;
  padding: 0;
  height: auto;
  min-height: unset;
  font-size: inherit;
  text-transform: none;
  font-weight: normal;
}

.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.drop-zone {
  border: 2px dashed grey;
  color: grey;
  text-align: center;
  transition: border 0.2s ease;
}

.drag-over {
  border: 2px dashed var(--ion-color-primary, #3dc2ff);
  color: var(--ion-color-primary, 'yellow');
  text-align: center;
  background-color:rgba(255, 255, 255, 0.1);
}

.file-uploader-bar {
  display: block;
  width: 100%;
  height: 60px;
  position: relative;
}


.file-uploader-square {
  display: inline-block;
  margin: 4px;
  position: relative;
  vertical-align: top;

  width: 160px;
  height: 200px;
  border: 1px solid grey;
}

ion-action-sheet.folder-selector .action-sheet-title {
  color: #fff;
  background-color: var(--ion-color-step-800);
}
